<template>
  <q-card>
    <q-card-section>
      <q-list separator bordered v-if="items.length>0">
        <q-item class="bg-blue text-white">
          <q-item-section>
            <q-item-label class="text-subtitle2">محصولات وابسته</q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-badge color="red" text-color="white" :label="items.length"/>
          </q-item-section>
        </q-item>

        <q-item v-for="(item, index) in items" :key="index">
          <q-item-section side>
            <q-btn icon="delete" color="red" flat round v-if="!isSelectForm"
                   @click="$emit('remove-item', item)"/>
          </q-item-section>
          <q-item-section>
            <q-item-label class="text-subtitle2">{{ item.Goods_Name }}</q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-badge color="red" text-color="white" :label="item.Goods_Code"/>
          </q-item-section>
        </q-item>

        <q-item replace v-if="!isSelectForm">
          <q-item-section align="center">
            <q-btn color="primary" text-color="white" label="تایید" @click="modifyDependency"/>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
  </q-card>
</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "ProductDependency",
  props: {
    goodsInfo: {
      type: Object,
    },
    items: {
      type: Array,
      default: () => []
    },
    isSelectForm: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      setDependency: 'Products/setProductDependency'
    }),
    modifyDependency() {
      this.setDependency({
        Goods_ID: this.goodsInfo.Goods_ID,
        items: JSON.stringify(this.items)
      }).then(() => {
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          position: 'top',
          message: 'اطلاعات ثبت گردید'
        })
      })
    }
  },
}
</script>

<style scoped>

</style>